/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SQLSession {
  blockedBy?: number;
  client?: string;
  cpuTime?: number;
  databaseName?: string;
  hostName?: string;
  ipAddress?: string;
  memoryUsage?: number;
  sessionId?: number;
  softwareName?: string;
  sqlCommand?: string;
  transactionBeginTime?: Date;
  transactionDuration?: number;
  transactionType?: string;
  username?: string;
}
